<div class="card rounded">
  <div>
    <div *ngIf="member$ | async as member">
      <div class="info-container">
        <label class="mb-1 personal-info">{{ 'account.details.email' | translate }}</label>
        <div class="d-flex align-items-center bg-muted p-2 m-0 rounded">
          <span class="icon material-icons" aria-hidden="true">email</span>
          <span class="ms-3">{{ member.EmailAddress1 }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
